import React, { useEffect, useState } from "react";
import "./App.css";

function App() {

  const [clientes, setClientes] = useState([]);

  // 🔹 Traer datos del backend
  useEffect(() => {
    fetch("http://127.0.0.1:5000/api/clientes")
      .then(response => response.json())
      .then(data => {
        console.log("Datos recibidos:", data);
        setClientes(data);
      })
      .catch(error => console.error("Error:", error));
  }, []);

  return (
    <div className="container">
      <h1>Lista de Clientes</h1>

      <table className="tabla-clientes">
        <thead>
          <tr>
            <th>NIF</th>
            <th>Nombre</th>
            <th>Dirección</th>
            <th>Teléfono</th>
          </tr>
        </thead>
        <tbody>
          {clientes.map((cliente, index) => (
            <tr key={index}>
              <td>{cliente.nif}</td>
              <td>{cliente.nombre}</td>
              <td>{cliente.direccion}</td>
              <td>{cliente.telefono}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default App;